import React, { useState } from "react";
import "./others.css";
import { CiFolderOn } from "react-icons/ci";
import { FiExternalLink } from "react-icons/fi";
import { Fade } from "react-reveal";
import { usePortfolioData } from "../../hooks/usePortfolioData";

const Others = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { data, loading } = usePortfolioData();

  if (loading || !data) {
    return (
      <div className="others-container">
        <div>Loading...</div>
      </div>
    );
  }

  const TopProjects = data.otherProjects || [
    {
      id: 1,
      projectName: "Qevolt",
      projectDesc:
        "Qevolt helps businesses accept bank transfers from customers swiftly and securely. Accept payments without fear of fake alerts and delayed transactions.",
      projectTech: ["React", "Git", "Netlify", "TypeScript", "CSS"],
      img: "./assets/qevolt.png",
      link: "https://qevolt-dll.vercel.app/",
    },
    {
      id: 2,
      projectName: "Qevolt Music",
      projectDesc:
        "Qevolt Music is a dynamic website showcasing the curated music shared by the Qevolt team on our Slack channel, providing a platform to discover and enjoy a diverse range of musical genres.",
      projectTech: ["Next", "CSS", "Netlify", "Node"],
      img: "",
      link: "https://qevolt-dll.vercel.app/music",
    },
    {
      id: 3,
      projectName: "Lumiwrld",
      projectDesc:
        "Lumiwrld, a Nigerian entertainment brand, redefines the industry narrative with top-tier services and cutting-edge content created by young African talents. Our mission is to unite cultures and celebrate the rich diversity of Africa.",
      projectTech: ["Next", "CSS", "Vercel"],
      img: "",
      link: "https://www.lumiwrld.com/",
    },
    {
      id: 4,
      projectName: "Qevolt Version 1.0",
      projectDesc:
        "Qevolt version 1. Qevolt enables businesses to securely accept bank transfers, providing a reliable payment solution for enhanced transactional security.",
      projectTech: ["React", "CSS", "Netlify"],
      img: "",
      link: "https://qevolt-v1.netlify.app/",
    },

    {
      id: 5,
      projectName: "GitFinder",
      projectDesc:
        "GitFinder is a web app for showcasing your GitHub profile and repositories. Powered by React.js and the GitHub API, it offers an intuitive interface, clean design, and seamless navigation. ",
      projectTech: ["React", "CSS", "Surge"],
      img: "./assets/gitfinder.png",
      link: "https://gitfinder-dll.surge.sh/",
    },

    {
      id: 6,
      projectName: "Textdex",
      projectDesc:
        "Built with React, the chat application utilizes Firebase for seamless Google and Twitter authentication, along with the ChatEngine API, providing a robust platform for real-time communication and social interaction.",
      projectTech: ["React", "CSS", "Surge", "Firebase"],
      img: "",
      link: "http://textdex.surge.sh/",
    },
    {
      id: 7,
      projectName: "Space Tourism",
      projectDesc:
        "Space Tourism is a platform for space enthusiasts to organize and plan their extraordinary space travel experiences, igniting the spirit of exploration. ",
      projectTech: ["React", "CSS", "Surge"],
      img: "",
      link: "http://space-dll.surge.sh/",
    },
    {
      id: 8,
      projectName: "Powerdeals Redesign 1",
      projectDesc:
        "A quick redesign of the Powerdeals website (https://powerdeals.ng/), with a focus on improving the user experience and making the website more responsive, concise and user-friendly.",
      projectTech: ["React", "CSS", "Vercel"],
      img: "",
      link: "https://powerdeals.vercel.app/",
    },
    {
      id: 9,
      projectName: "Send Order Btn",
      projectDesc: "A button with a pure css animation ",
      projectTech: ["React", "CSS", "Vercel"],
      img: "",
      link: "https://ship-order-btn-dll.vercel.app/",
    },
    {
      id: 10,
      projectName: "Cors Proxy",
      projectDesc:
        "A server i built to bypass cors from the client side as a proxy",
      projectTech: ["Node.js", "Express", "Vercel"],
      img: "",
      link: "https://cors-proxy-iota-weld.vercel.app/",
    },
  ];

  const handleMouseEnter = (itemId) => {
    console.log("Mouse entered the element!");
    setHoveredIndex(itemId);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  return (
    <div className="others-container">
      <Fade delay={100}>
        <div className="others-header">other projects</div>
      </Fade>

      <div className="others-contents">
        <Fade delay={200}></Fade>
        <div className="others-grid">
          {TopProjects.map((item) => (
            <a
              href={item.link}
              target="_blank"
              rel="noreferrer"
              className="topProject"
              key={item.id}
              onMouseEnter={() => handleMouseEnter(item.id)}
              onMouseLeave={handleMouseLeave}
            >
              <Fade delay={80 * item.id}>
                <div className="others-content">
                  <div className="folder-flex">
                    <div className="others-folder">
                      <CiFolderOn />
                    </div>

                    <div
                      className="folder-links"
                      style={{
                        color:
                          hoveredIndex === item.id ? "var(--accent-color)" : "",
                      }}
                    >
                      <FiExternalLink />
                    </div>
                  </div>

                  <div
                    className="otherProject-header"
                    style={{
                      color:
                        hoveredIndex === item.id ? "var(--accent-color)" : "",
                    }}
                  >
                    {item.projectName}
                  </div>
                  <div className="otherProject-text">{item.projectDesc}</div>
                  <ul className="otherProject-tech">
                    {item.projectTech.map((tech, index) => (
                      <li key={index}>{tech}</li>
                    ))}
                  </ul>
                </div>
              </Fade>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Others;
